import React from 'react';
import { Link } from 'react-router-dom';

const Footer = ({ cmsContent }) => {
  const currentYear = new Date().getFullYear();

  const twitterLink = cmsContent?.twitter_link || 'https://x.com/Signal_Bros';
  const instagramLink = cmsContent?.instagram_link || 'https://www.instagram.com/signalbrosteams/';

  const footerSections = [
    {
      title: 'Product',
      links: [
        { label: 'Features', path: '/#features', isExternal: false },
        { label: 'Pricing', path: '/pricing', isExternal: false },
        { label: 'Integrations', path: '#', isExternal: false },
        { label: 'Changelog', path: '#', isExternal: false }
      ]
    },
    {
      title: 'Company',
      links: [
        { label: 'About', path: '#', isExternal: false },
        { label: 'Blog', path: '#', isExternal: false },
        { label: 'X (Twitter)', path: twitterLink, isExternal: true },
        { label: 'Instagram', path: instagramLink, isExternal: true }
      ]
    },
    {
      title: 'Legal',
      links: [
        { label: 'Privacy', path: '/privacy', isExternal: false },
        { label: 'Terms', path: '/terms', isExternal: false },
        { label: 'Security', path: '#', isExternal: false }
      ]
    }
  ];

  const socialLinks = [
    { label: 'X', path: twitterLink, isExternal: true },
    { label: 'Instagram', path: instagramLink, isExternal: true },
    { label: 'GitHub', path: '#', isExternal: true },
    { label: 'Discord', path: '/pricing', isExternal: false }
  ];

  return (
    <footer style={{ 
      padding: '64px 0 32px', 
      borderTop: '1px solid var(--border)',
      background: 'var(--bg-secondary)',
      position: 'relative',
      zIndex: 1
    }}>
      <div className="container">
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
          gap: 48, 
          marginBottom: 48
        }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
              <img 
                src="/SB.png" 
                alt="SignalBros Logo" 
                style={{ 
                  width: 28, 
                  height: 28, 
                  borderRadius: 6 
                }} 
              />
              <span style={{ fontSize: 18, fontWeight: 600 }}>SignalBros</span>
            </div>
            <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
              The next-gen intelligence ecosystem for the modern trader.
            </p>
          </div>
          
          {footerSections.map((section, i) => (
            <div key={i}>
              <h5 style={{ 
                fontSize: 14, 
                fontWeight: 600, 
                marginBottom: 16,
                color: 'var(--text-primary)'
              }}>{section.title}</h5>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                {section.links.map((link, j) => (
                  link.isExternal ? (
                    <a 
                      key={j} 
                      href={link.path} 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ 
                        fontSize: 14, 
                        color: 'var(--text-secondary)',
                        textDecoration: 'none',
                        transition: 'var(--transition)'
                      }}
                    >
                      {link.label}
                    </a>
                  ) : (
                    link.path.startsWith('/#') ? (
                      <a 
                        key={j} 
                        href={link.path} 
                        style={{ 
                          fontSize: 14, 
                          color: 'var(--text-secondary)',
                          textDecoration: 'none',
                          transition: 'var(--transition)'
                        }}
                      >
                        {link.label}
                      </a>
                    ) : (
                      <Link 
                        key={j} 
                        to={link.path} 
                        style={{ 
                          fontSize: 14, 
                          color: 'var(--text-secondary)',
                          textDecoration: 'none',
                          transition: 'var(--transition)'
                        }}
                      >
                        {link.label}
                      </Link>
                    )
                  )
                ))}
              </div>
            </div>
          ))}
        </div>

        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          paddingTop: 24, 
          borderTop: '1px solid var(--border)',
          flexWrap: 'wrap',
          gap: 16
        }}>
          <div style={{ fontSize: 13, color: 'var(--text-muted)' }}>
            © {currentYear} SignalBros. All rights reserved.
          </div>
          <div style={{ display: 'flex', gap: 20 }}>
            {socialLinks.map((social, i) => (
              social.isExternal ? (
                <a 
                  key={i} 
                  href={social.path} 
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}
                >
                  {social.label}
                </a>
              ) : (
                <Link 
                  key={i} 
                  to={social.path} 
                  style={{ fontSize: 13, color: 'var(--text-muted)', textDecoration: 'none' }}
                >
                  {social.label}
                </Link>
              )
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
